/**
 * Rounds and formats a points value for display.
 *
 * @param {number|string} value - The points value to format.
 * @returns {string} The formatted points value.
 */
export const roundPointsValue = (value) => {
  const formattedNumber = Number(value);
  let result;

  if (isNaN(formattedNumber)) {
    result = "-";
  } else if (formattedNumber < 1000) {
    result = formattedNumber.toString();
  } else if (formattedNumber < 10000) {
    const rounded = Math.ceil(formattedNumber / 100) * 100;

    result = `${(rounded / 1000).toFixed(1)}k`;
  } else {
    const rounded = Math.ceil(formattedNumber / 1000) * 1000;

    result = `${Math.round(rounded / 1000).toString()}k`;
  }

  return result;
};
